var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentName,{ref:"methodology",tag:"component",attrs:{"display-type":_vm.displayType,"portfolio":_vm.checkupStore.portfolio,"benchmark":_vm.checkupStore.benchmark,"optimized-portfolio":_vm.checkupStore.optimizedPortfolio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }